<template>
    <div class="page-container">
        <div class="container-fluid">
            <!-- Kemas kini aplikasi (hanya jika ada versi baharu) -->
            <div v-if="updateAvailable" class="alert pwa-update-alert d-flex justify-content-between align-items-center" role="alert">
                <span class="pr-3">
                    <i class="fas fa-sync-alt"></i>
                    Versi baharu aplikasi tersedia
                </span>
                <button type="button" class="btn btn-sm btn-light flex-shrink-0" :disabled="updating" @click="applyUpdate">
                    {{ updating ? 'Mengemas kini...' : 'Kemas kini' }}
                </button>
            </div>

            <!-- Page Header -->
            <div class="page-header">
                <h2 class="page-title">Portal Mahasiswa</h2>
                <!-- <p class="page-subtitle">Akses Cepat Layanan Akademik</p> -->

                <!-- Maklumat ringkas pelajar -->
                <div v-if="student" class="student-summary">
                    <img :src="student.photo" class="student-summary-photo" alt="Foto Pelajar" @error="onPhotoError">
                    <div class="student-summary-id">{{ student.student_id }}</div>
                    <div class="student-summary-name">{{ student.name }}</div>
                </div>
            </div>
            
            <div class="row justify-content-center">
                <!-- Profile Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'profile'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-user-circle"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Profile</h3>
                                <p class="card-description">Lihat & edit profil</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Attendance Report Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'attendance'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-calendar-check"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Laporan Kehadiran</h3>
                                <p class="card-description">Riwayat kehadiran kuliah</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Study Result Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'studyResult'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-graduation-cap"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Hasil Kuliah</h3>
                                <p class="card-description">Nilai & transkrip</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Tamhidi Result Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'TamhidiResult'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-certificate"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Hasil Tamhidi / Mustawa</h3>
                                <p class="card-description">Hasil program persiapan</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Payment History Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'payment'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-receipt"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Sejarah Bayaran</h3>
                                <p class="card-description">Riwayat pembayaran</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Permohonan Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'Applications'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-file-alt"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Permohonan</h3>
                                <p class="card-description">Buat & pantau permohonan</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Muat Turun Borang Menu -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'FormDownload'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-file-download"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Muat Turun Borang</h3>
                                <p class="card-description">Borang rasmi institusi</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Pengumuman Institusi -->
                <div class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'announcement'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-bullhorn"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Pengumuman</h3>
                                <p class="card-description">Pengumuman penting</p>
                            </div>
                        </div>
                    </router-link>
                </div>

                <!-- Latihan Ilmiah (hanya jika ada pendaftaran) -->
                <div v-if="hasLatihanIlmiah" class="col-6 col-lg-3 col-md-4 mb-4">
                    <router-link :to="{name: 'latihanIlmiah'}" class="card-link h-100">
                        <div class="theme-card">
                            <div class="icon-wrapper">
                                <i class="fas fa-book-reader"></i>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">Latihan Ilmiah</h3>
                                <p class="card-description">Laporan kemajuan</p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>

        <!-- Popup pengumuman belum dibaca -->
        <div class="modal fade" id="announcementPopup" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-bullhorn"></i>
                            Pengumuman ({{ unreadAnnouncements.length }})
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul class="list-group">
                            <li
                                class="list-group-item announcement-popup-item d-flex justify-content-between align-items-center"
                                v-for="a in unreadAnnouncements"
                                :key="a.id"
                                @click="goToAnnouncement(a.id)"
                            >
                                <div class="pr-3">
                                    <div class="font-weight-bold">{{ a.title }}</div>
                                    <small class="text-muted">{{ a.summary }}</small>
                                    <small class="d-block text-muted mt-1">
                                        <i class="far fa-calendar-alt"></i> {{ a.start_at }}
                                    </small>
                                </div>
                                <small class="announcement-readmore flex-shrink-0">
                                    Baca selengkapnya <i class="fas fa-chevron-right"></i>
                                </small>
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Tutup</button>
                        <button type="button" class="btn btn-primary" @click="goToAnnouncementFeed">
                            Lihat Semua Pengumuman
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { checkForUpdate, applyUpdate } from '@/registerServiceWorker'

export default {
    name: 'DashboardMenu',
    data() {
        return {
            unreadAnnouncements: [],
            hasLatihanIlmiah: false,
            updating: false,
            student: null,
        }
    },
    computed: {
        updateAvailable() {
            return this.$store.state.pwa.updateAvailable
        },
    },
    mounted() {
        checkForUpdate()   // เจอเวอร์ชันใหม่ → registerServiceWorker commit pwa/updateAvailable → แถบด้านบนโผล่
        this.loadStudentSummary()
        this.loadActiveAnnouncements()
        this.loadLatihanIlmiahExists()
    },
    methods: {
        // หน้าจะ reload เองเมื่อ SW ใหม่เข้าควบคุม
        applyUpdate() {
            this.updating = true
            applyUpdate()
        },

        // ใช้ endpoint เดียวกับหน้า Profile (profile/biodata) — error = ซ่อนส่วนนี้เฉยๆ ไม่ต้องแจ้ง
        async loadStudentSummary() {
            try {
                const { data } = await this.$store.dispatch('profile/retreiveBiodata')
                this.student = {
                    student_id: data.biodata.student_id,
                    name: `${data.biodata.firstname_rumi || ''} ${data.biodata.lastname_rumi || ''}`.trim(),
                    photo: data.photo ? 'https://kisda.online/images/' + data.photo.images : '/avatar.png',
                }
            } catch (error) {
                if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                    this.$store.dispatch('authentication/cencelAuthen')
                }
                // eslint-disable-next-line no-console
                console.log(error)
            }
        },

        // รูปบน server หาย/โหลดไม่ได้ → ใช้รูป default
        onPhotoError(event) {
            event.target.src = '/avatar.png'
        },

        // v2: /announcement/active กรอง "ยังไม่อ่าน" ฝั่ง server แล้ว (อิง DB ต่อนักเรียน)
        // → ข้ามอุปกรณ์/เบราว์เซอร์ได้ ไม่ต้องเทียบ localStorage อีกต่อไป; มีรายการ = เด้ง popup
        async loadActiveAnnouncements() {
            try {
                this.unreadAnnouncements = await this.$store.dispatch('announcement/fetchActive')

                if (this.unreadAnnouncements.length) {
                    $('#announcementPopup').modal('show')
                }
            } catch (error) {
                if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                    this.$store.dispatch('authentication/cencelAuthen')
                }
                // eslint-disable-next-line no-console
                console.log(error)
            }
        },

        // การ์ด Latihan Ilmiah แสดงเฉพาะเมื่อมี registration (ไม่ใช่ dibatalkan) — error = ซ่อนการ์ดเฉยๆ
        async loadLatihanIlmiahExists() {
            try {
                this.hasLatihanIlmiah = await this.$store.dispatch('latihanIlmiah/fetchExists')
            } catch (error) {
                // eslint-disable-next-line no-console
                console.log(error)
            }
        },

        // คลิกรายการ → ปิด popup แล้วไปหน้า detail (detail จะ markRead ลง DB เอง)
        goToAnnouncement(id) {
            $('#announcementPopup').modal('hide')
            this.$router.push({ name: 'announcementDetail', params: { id } })
        },

        goToAnnouncementFeed() {
            $('#announcementPopup').modal('hide')
            this.$router.push({ name: 'announcement' })
        },
    },
}
</script>

<style scoped>
/* Component-specific styles - theme.css handles most styling */
.student-summary {
    margin-top: var(--spacing-md);
}
.student-summary-photo {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid var(--primary-color);
}
.student-summary-id {
    margin-top: 8px;
    font-weight: 700;
    color: var(--primary-color);
}
.student-summary-name {
    color: var(--text-primary);
}
.pwa-update-alert {
    background-color: var(--primary-color);
    color: #fff;
    border: none;
}
.announcement-popup-item {
    cursor: pointer;
    transition: background-color 0.15s ease;
}
.announcement-popup-item:hover {
    background-color: #f1f8f3;
}
.announcement-readmore {
    color: var(--primary-color);
    font-weight: 600;
    white-space: nowrap;
}
</style>